import { PortalType } from '@studyportals/domain-client';
import IUVisibilityHelper from '../../models/iu/IUVisibilityHelper';

class EventsSender {
	public sendInitialEvents(portalType: PortalType): void {
		this.sendBestFitEvents(portalType);
		this.sendGlobalAccessInitiativeEvent(portalType);
		this.sendWishlistEvents();
		this.sendSearchPageEvents();
	}

	public sendChangeCurrencyEvent(): void {
		document.dispatchEvent(new CustomEvent('open_localization_settings'));
	}

	public initializeRecommendations(recommendationsIdentifier: string): void {
		document.dispatchEvent(
			new CustomEvent('recommendations_initialize', {
				detail: {
					identifier: recommendationsIdentifier
				}
			})
		);
	}

	public subscribeToRecommendationsEvents = (recommendationsIdentifier: string): void => {
		document.addEventListener('recommendations_ready', () => {
			this.initializeRecommendations(recommendationsIdentifier);
		});

		document.addEventListener('contentChanged', () => {
			this.initializeRecommendations(recommendationsIdentifier);
		});
	};

	private sendBestFitEvents(portalType: PortalType): void {
		if (portalType === PortalType.MASTER) {
			document.dispatchEvent(
				new CustomEvent('profile_questionnaires_initialize', {
					detail: {
						identifier: 'bestfit_search'
					}
				})
			);
			document.dispatchEvent(new Event('render_best_fit_templates'));
		}
	}

	private sendGlobalAccessInitiativeEvent(portalType: PortalType): void {
		if (IUVisibilityHelper.eligiblePortalType(portalType)) {
			document.dispatchEvent(
				new CustomEvent('profile_questionnaires_initialize', {
					detail: {
						identifier: 'search_global_access_initiative_label'
					}
				})
			);

			document.dispatchEvent(
				new CustomEvent('profile_questionnaires_initialize', {
					detail: {
						identifier: 'search_scholarship_incentive_label'
					}
				})
			);
		}
	}

	private sendWishlistEvents(): void {
		document.dispatchEvent(new Event('wishlist_button_initialize'));
	}

	private sendSearchPageEvents(): void {
		document.dispatchEvent(new Event('render_complete'));
	}
}

export default new EventsSender();
